import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row galleryDesktopSlider" };
const _hoisted_2 = {
    key: 0,
    class: "warrantyPatch",
    alt: "36 Monate Garantie",
    src: "/images/_new_brand/product_detail_page/36_monate_garantie.png",
    style: { "width": "150px", "max-width": "30%", "position": "absolute", "left": "-5%", "bottom": "28%", "z-index": "3" }
};
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "carousel__item__gallery" };
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 1,
    class: "col-10 offset-1"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_slide = _resolveComponent("slide");
    const _component_Carousel = _resolveComponent("Carousel");
    const _component_navigation = _resolveComponent("navigation");
    const _component_pagination = _resolveComponent("pagination");
    const _component_carousel = _resolveComponent("carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.hasExtendedWarrantyMonth) === 36)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Carousel, {
                "items-to-show": 1,
                "wrap-around": false,
                modelValue: _ctx.currentSlide,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.currentSlide) = $event))
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allImages, (src, index) => {
                        return (_openBlock(), _createBlock(_component_slide, { key: index }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("img", {
                                        onClick: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.triggerFancyBox && _ctx.triggerFancyBox(...args))),
                                        src: _ctx.optimizeImage(src, 625),
                                        class: "bigGalleryImage",
                                        alt: "Produktbild"
                                    }, null, 8, _hoisted_5)
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            }, 8, ["modelValue"])
        ]),
        (_ctx.allImages.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_carousel, {
                    "items-to-show": _ctx.thumbnailQuantity,
                    "wrap-around": true,
                    ref: "carousel",
                    modelValue: _ctx.currentSlide,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.currentSlide) = $event))
                }, {
                    addons: _withCtx(() => [
                        _createVNode(_component_navigation),
                        _createVNode(_component_pagination)
                    ]),
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allImages, (src, index) => {
                            return (_openBlock(), _createBlock(_component_slide, { key: index }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: "carousel__item",
                                        onClick: ($event) => (_ctx.slideTo(index))
                                    }, [
                                        _createElementVNode("img", {
                                            src: _ctx.optimizeImage(src, 180),
                                            title: "Produktbild Vorschau",
                                            alt: "Produkt Vorschau",
                                            style: { "width": "100%", "aspect-ratio": "1/1", "object-fit": "contain" }
                                        }, null, 8, _hoisted_8)
                                    ], 8, _hoisted_7)
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["items-to-show", "modelValue"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
